import React from "react";
import { STATS } from "../../lib/site-data";

export default function StatsBand() {
  return (
    <section
      data-testid="stats-band"
      className="relative bg-cream py-20 lg:py-24"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16 border-t border-ink/10 pt-14">
          {STATS.map((s, i) => (
            <div
              key={s.label}
              data-testid={`stat-${i}`}
              className="flex flex-col"
            >
              <p className="font-display text-ink text-[52px] sm:text-[64px] lg:text-[80px] font-extrabold leading-[0.95] tracking-tight">
                {s.value}
              </p>
              <p className="mt-4 max-w-xs text-[15.5px] text-ink/65 leading-relaxed">
                {s.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
